module.exports = __webpack_public_path__ + "c19b93a8e779af4680f2f47eb9e0ea95.pdf";